import { render, staticRenderFns } from "./ElevationTab.vue?vue&type=template&id=ca97d3d6&scoped=true"
import script from "./ElevationTab.vue?vue&type=script&lang=js"
export * from "./ElevationTab.vue?vue&type=script&lang=js"
import style0 from "./ElevationTab.vue?vue&type=style&index=0&id=ca97d3d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca97d3d6",
  null
  
)

export default component.exports